<template>
    <div class="company-select-main">
        <div class="customer-select-title text-center">Please select the specific business you are purchasing for to better customize your ordering experience</div>
        <hr class="company-select-hr" />
        <div class="container-fluid p-0 px-sm-3">
            <div class="row mx-sm-n3 mb-4">
                <!--please make this a loop, thanks-->
                <div class="col-sm-4 px-sm-3">
                    <div role="button" class="company-card" v-on:click="setCompany('KOCBUS')">
                        <div class="logo">
                            <img :src="kochImageUrl" alt="Koch Logo" />
                        </div>
                        <hr class="separator" />
                        <div class="d-flex justify-content-between align-items-center link">
                            <div>Koch Bundles and Devices</div>
                            <img :src="arrow" />
                        </div>
                    </div>
                </div>
                <div class="col-sm-4 px-sm-3">
                    <div role="button" class="company-card" v-on:click="setCompany('KOCHGP')">
                        <div class="logo">
                            <img :src="gpImageUrl" alt="Georgia Pacific Logo" />
                        </div>
                        <hr class="separator" />
                        <div class="d-flex justify-content-between align-items-center link">
                            <div>GP Bundles and Devices</div>
                            <img :src="arrow" />
                        </div>
                    </div>
                </div>
                <div class="col-sm-4 px-sm-3">
                    <div role="button" class="company-card" v-on:click="setCompany('KOCMOL')">
                        <div class="logo">
                            <img :src="molexImageUrl" alt="Molex Logo" />
                        </div>
                        <hr class="separator" />
                        <div class="d-flex justify-content-between align-items-center link">
                            <div>Molex Bundles and Devices</div>
                            <img :src="arrow" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mx-sm-n3">
                <div class="col-sm-4 px-sm-3">
                    <div role="button" class="company-card" v-on:click="setCompany('KOCGUA')">
                        <div class="logo">
                            <img :src="guardianImageUrl" alt="Guardian Logo" />
                        </div>
                        <hr class="separator" />
                        <div class="d-flex justify-content-between align-items-center link">
                            <div>Guardian Bundles and Devices</div>
                            <img :src="arrow" />
                        </div>
                    </div>
                </div>
                <div class="col-sm-4 px-sm-3">
                    <div role="button" class="company-card" v-on:click="setCompany('KOCINV')">
                        <div class="logo">
                            <img :src="invistaImageUrl" alt="Invista Logo" />
                        </div>
                        <hr class="separator" />
                        <div class="d-flex justify-content-between align-items-center link">
                            <div>Invista Bundles and Devices</div>
                            <img :src="arrow" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import axois from 'axios';

    export default {
        name: 'CompanySelect',
        data() {
            return {
                kochImageUrl: '/images/Company/KOCH.svg',
                gpImageUrl: '/images/Company/GeorgiaPacificLogo.svg',
                molexImageUrl: '/images/Company/MOLEX.svg',
                arrow: '/images/Company/arrow.svg',
                guardianImageUrl: '/images/KochCompanies/GuardianLogo.svg',
                invistaImageUrl: '/images/KochCompanies/InvistaLogo.svg',
            }
        },
        created() {

        },
        methods: {
            setCompany(company) {
                var self = this;

                axois.get(`/api/ProductCatalog/GetProductCatalog?subsidiary=${company}`, {
                    headers: {
                        'Authorization': `Bearer ${self.$store.getters.jwtToken}`
                    }
                }).then(function (response) {
                    self.$store.commit('setProductCatalog', response.data.value.products);
                    const cpy = self.$store.getters.getKochCompanies.find(x => x.accountNumber === company);
                    self.$store.commit('setCompany', cpy);
                    router.push({ path: "/ProductCatalog" });
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../wwwroot/css/pages/company-select.scss";
</style>
